
import React from 'react';
import { CheckCircle } from 'lucide-react';

const SolutionVision = () => {
  return (
    <div className="mb-12 sm:mb-16 md:mb-20">
      <div className="relative">
        <div className="absolute -inset-0.5 sm:-inset-1 bg-gradient-to-r from-[#003a70] to-[#003a70]/80 rounded-2xl sm:rounded-3xl blur opacity-20"></div>
        <div className="relative bg-gradient-to-br from-[#003a70] to-[#003a70]/90 rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl">
          <div className="p-6 sm:p-8 md:p-10 lg:p-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 sm:mb-8 md:mb-10 text-center text-white">
              Now, Picture This Instead...
            </h2>
            
            <div className="grid gap-6 sm:gap-8">
              <div className="flex items-start gap-4 sm:gap-6 group">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-[#FEE6D8]/20 rounded-lg sm:rounded-xl flex items-center justify-center backdrop-blur-sm border border-[#FEE6D8]/30">
                    <CheckCircle className="text-[#FEE6D8]" size={16} />
                  </div>
                </div>
                <p className="text-white text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
                  What if you could approach a local business with a solution <strong className="text-[#FEE6D8]">SO obviously helpful, SO incredibly relevant to their daily frustrations, and SO surprisingly affordable</strong> that their interest is immediately piqued?
                </p>
              </div>
              
              <div className="flex items-start gap-4 sm:gap-6 group">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-[#FEE6D8]/20 rounded-lg sm:rounded-xl flex items-center justify-center backdrop-blur-sm border border-[#FEE6D8]/30">
                    <CheckCircle className="text-[#FEE6D8]" size={16} />
                  </div>
                </div>
                <p className="text-white text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
                  What if this solution was so remarkably easy for you to set up and manage <span className="text-[#FEE6D8] font-semibold">(we're talking minimal time investment, using a tool that's 100% no-code)</span> that it actually felt good to offer?
                </p>
              </div>
              
              <div className="flex items-start gap-4 sm:gap-6 group">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-[#FEE6D8]/20 rounded-lg sm:rounded-xl flex items-center justify-center backdrop-blur-sm border border-[#FEE6D8]/30">
                    <CheckCircle className="text-[#FEE6D8]" size={16} />
                  </div>
                </div>
                <p className="text-white text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
                  And what if this single, simple offering served as the perfect <strong className="text-[#FEE6D8]">"Trusted Advisor" entry point</strong> – a way to demonstrate your value, build immediate rapport, and naturally open conversations about how your other expert services can help them thrive?
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionVision;
